import { useEffect, useRef } from 'react';
import type { TelegramWidgetUser } from '../api/auth';

declare global {
  interface Window {
    vbbTelegramAuth?: (user: TelegramWidgetUser) => void;
  }
}

/** Official Telegram Login Widget; only works on the domain registered for the bot via BotFather /setdomain. */
export function TelegramLoginButton({
  botUsername,
  onAuth,
  size = 'large',
}: {
  botUsername: string;
  onAuth: (user: TelegramWidgetUser) => void;
  size?: 'large' | 'medium' | 'small';
}) {
  const container = useRef<HTMLDivElement>(null);

  useEffect(() => {
    window.vbbTelegramAuth = onAuth;
    const host = container.current;
    if (!host) return undefined;
    const script = document.createElement('script');
    script.src = 'https://telegram.org/js/telegram-widget.js?22';
    script.async = true;
    script.setAttribute('data-telegram-login', botUsername);
    script.setAttribute('data-size', size);
    script.setAttribute('data-userpic', 'false');
    script.setAttribute('data-radius', '10');
    script.setAttribute('data-request-access', 'write');
    script.setAttribute('data-onauth', 'vbbTelegramAuth(user)');
    host.replaceChildren(script);
    return () => {
      host.replaceChildren();
      delete window.vbbTelegramAuth;
    };
  }, [botUsername, onAuth, size]);

  return <div className="telegram-widget" ref={container} />;
}
